import React from "react";

import { TableBlock as Value } from "@reactivated";

import { concatClassNames } from "../../utils/styles";

import styles from "./index.module.scss";

export const TableBlock = ({
    value,
    className,
}: {
    value: Value;
    className?: string;
}) => {
    return React.createElement("div", {
        className: concatClassNames([className ?? "", styles.table]),
        dangerouslySetInnerHTML: {
            __html: value,
        },
    });
};
